import { useEffect, useRef, useState } from "react";
import { TargetFull } from "../../classes/targetFull";
import { Vector } from "../../classes/vector";
import CountDownTimer from "../../components/common/countDownTimer";
import Play from "../../components/common/play";
import ChallengeNavBar from "../../components/challenge/challengeNavbar";
import ChallengeResults from "../../components/challenge/challengeResults";
import ChallengeSettings from "../../components/challenge/challengeSettings";
import gunshot from "../../assets/sounds/gunshot.mp3";
import gunReload from "../../assets/sounds/shotgun-reload.mp3";
import { useStorageActions } from "../../context/storageContext";
import restart from "../../assets/restart.png";
import fullScreen from "../../assets/full_screen.png";
import sound from "../../assets/sound.png";
import settings from "../../assets/settings.png";
import soundHover from "../../assets/soundHover.png";
import settingsHover from "../../assets/settingsHover.png";
import LifeIndicator from "../../components/common/lifeIndicator";
import { Helmet } from "react-helmet";

const paddingX = window.innerWidth < 750 ? 50 : 60;

function clearCanvas(ctx, canvasRef) {
  ctx?.clearRect(
    0,
    0,
    canvasRef?.current?.clientWidth,
    canvasRef?.current?.clientHeight
  );
}

const ChallengeArena = () => {
  const [ctx, setCtx] = useState(null);
  const canvasRef = useRef(null);
  const startTimeRef = useRef(Date.now());
  const [totalLifes, setTotalLifes] = useState(5);
  const [lifes, setlifes] = useState(totalLifes);
  const lifesRef = useRef(totalLifes);
  const gameLoops = useRef(0);
  const [speed, setSpeed] = useState(0);
  const playingRef = useRef(false);
  const [playing, setPlaying] = useState(playingRef.current);
  const [gameStarted, setGameStarted] = useState(false);
  const [isCountDown, setIsCountDown] = useState(false);
  const TARGETS = useRef([]);
  const data = useRef({ totalTargets: 0, targets: [], finishTime: null });
  const [hits, setHits] = useState(0);
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  const [spawnRateLimit, setSpawnRateLimit] = useState(800);
  const [spawnRateIncrease, setSpawnRateIncrease] = useState(150);
  const [isSoundOn, setIsSoundOn] = useState(true);
  const gunshotRef = useRef(null);
  const gunReloadRef = useRef(null);
  const { addChallengeScore } = useStorageActions();

  const [canvasHeight, setCanvasHeight] = useState(window.innerHeight - 190);
  useEffect(() => {
    window.addEventListener("resize", () =>
      setCanvasHeight(window.innerHeight - 190)
    );
  }, []);

  useEffect(() => {
    if (isSettingsOpen && playing) {
      finishGame();
    }
  }, [isSettingsOpen]);

  useEffect(() => {
    setlifes(totalLifes);
  }, [totalLifes]);

  useEffect(() => {
    if (canvasRef && canvasRef.current) {
      console.log({ canvasRef });
      const canvas = document.getElementById("canvas");
      canvas.focus();
      const ctx = canvas.getContext("2d");
      canvasRef.current.focus();
      setCtx(ctx);
    }
  }, [canvasRef]);

  useEffect(() => {
    let reqID = null;
    if (ctx && playing) {
      console.log("playing....");
      setIsCountDown(true);
      setTimeout(() => {
        console.log("started....");
        setIsCountDown(false);

        reqID = requestAnimationFrame(mainLoop);
      }, 2000);

      return () => {
        if (reqID) {
          cancelAnimationFrame(reqID);
        }
      };
    }
  }, [ctx, playing]);

  function startGame() {
    if (!gameStarted) {
      setGameStarted(true);
    }

    clearCanvas(ctx, canvasRef);
    setPlaying(true);
    setIsCountDown(true);
    setlifes(totalLifes);
    setHits(0);
    gameLoops.current = 0;
    startTimeRef.current = Date.now();
    lifesRef.current = totalLifes;
    TARGETS.current = [];
    playingRef.current = true;
    if (isSoundOn) {
      gunReloadRef.current.pause();
      gunReloadRef.current.currentTime = 0;
      gunReloadRef.current.play();
    }
  }

  function finishGame() {
    clearCanvas(ctx, canvasRef);
    data.current.finishTime = Date.now();
    setPlaying(false);
    playingRef.current = false;
    if (gameStarted) {
      addChallengeScore(data.current);
    }
  }

  function decreaseLife() {
    lifesRef.current = lifesRef.current - 1;
    console.log(lifesRef.current);
    setlifes(lifesRef.current);
  }

  function addTarget(targets) {
    if (canvasRef && canvasRef.current) {
      const x = 20 + Math.random() * (canvasRef.current.clientWidth - 100);
      const y = 20 + Math.random() * (canvasRef.current.clientHeight - 100);
      const target = new TargetFull(x, y, 30, targets, data, speed);
      data.current.totalTargets = data.current.totalTargets + 1;
    }
  }

  function die(targets) {
    for (let i = 0; i < targets.current.length; i++) {
      if (targets.current[i].canDie()) {
        if (!targets.current[i].isClicked) {
          decreaseLife();
          if (lifesRef.current === 0) {
            finishGame();
            clearCanvas(ctx, canvasRef);
          }
        }
        targets.current.splice(i, 1);
      }
    }
  }

  function mainLoop(timestamp) {
    if (playingRef.current) {
      clearCanvas(ctx, canvasRef);
      die(TARGETS);
      let spawnBuffer = spawnRateLimit;
      if (gameLoops.current * spawnRateIncrease < 2000 - spawnBuffer) {
        spawnBuffer = 2000 - gameLoops.current * spawnRateIncrease;
      }
      if (Date.now() > startTimeRef.current + spawnBuffer) {
        addTarget(TARGETS);
        startTimeRef.current = Date.now();
        gameLoops.current = gameLoops.current + 1;
      }
      TARGETS.current.forEach((b, index) => {
        b.updateCreature(ctx);
      });
      requestAnimationFrame(mainLoop);
    } else {
      clearCanvas(ctx, canvasRef);
    }
  }

  function handleCanvasClick(e) {
    e.preventDefault();
    let canvasElem = document.querySelector("canvas");
    let rect = canvasElem.getBoundingClientRect();

    const mouse = new Vector(e.clientX - rect.left, e.clientY - rect.top);
    if (isSoundOn) {
      gunshotRef.current.pause();
      gunshotRef.current.currentTime = 0;
      gunshotRef.current.play();
    }
    const targets = TARGETS.current;
    for (let i = 0; i < targets.length; i++) {
      if (
        targets[i].pos.subtr(mouse).mag() < targets[i].orignalR &&
        targets[i].isActive
      ) {
        setHits(hits + 1);
        targets[i].isClicked = true;
        targets[i].clickedTime = Date.now();
        targets[i].setClickedRadius();
        targets[i].clickPos = mouse;
      }
    }
  }

  function handleKeyDown(e) {
    e.preventDefault();
    if (e.keyCode === 32 || e.keyCode === 27 || e.keyCode === 82) {
      console.log("space key pressed");
      finishGame();
    }
    if (e.keyCode === 70) {
      console.log("full-screen mode");
      document.documentElement.requestFullscreen();
    }
  }

  return (
    <div
      onKeyDown={handleKeyDown}
      tabIndex={0}
      style={{
        height: "100%",
        width: "100%",
        overflowY: "hidden",
      }}
      className="d-flex flex-column"
    >
      <Helmet>
        <title>Custom Challenge Mode | OG Aim Trainer</title>
        <meta
          property="og:title"
          content="Custom Challenge Mode | OG Aim Trainer"
        />
        <meta
          name="description"
          content="The custom challenge mode is an all-in-one challenge for gamers to enhance their FPS shooting. It offers single targets, double targets, and moving targets all combined in one."
        />
        <meta
          property="og:description"
          content="The custom challenge mode is an all-in-one challenge for gamers to enhance their FPS shooting. It offers single targets, double targets, and moving targets all combined in one."
        />
      </Helmet>
      {isSoundOn ? (
        <div>
          <audio ref={gunshotRef} src={gunshot} />
          <audio ref={gunReloadRef} src={gunReload} />
        </div>
      ) : null}
      <ChallengeSettings
        isSettingsOpen={isSettingsOpen}
        setIsSettingsOpen={setIsSettingsOpen}
        spawnRateLimit={spawnRateLimit}
        spawnRateIncrease={spawnRateIncrease}
        setSpawnRateLimit={setSpawnRateLimit}
        setSpawnRateIncrease={setSpawnRateIncrease}
        totalLifes={totalLifes}
        setTotalLifes={setTotalLifes}
        speed={speed}
        setSpeed={setSpeed}
        startGame={startGame}
      />
      <ChallengeNavBar
        lifes={lifes}
        hits={hits}
        height={70}
        width={window.innerWidth}
        setIsSettingsOpen={setIsSettingsOpen}
        totalLifes={totalLifes}
        isSoundOn={isSoundOn}
        setIsSoundOn={setIsSoundOn}
      />

      <div
        className="d-flex justify-content-between aligns-items-center"
        style={{
          marginRight: 2 * paddingX,
          marginLeft: 2 * paddingX,
          marginTop: "auto",
          marginBottom: "auto",
          fontSize: "x-large",
          fontWeight: "900",
          color: "white",
        }}
        tabIndex={0}
      >
        <span className="mr-3" style={{ textAlign: "left" }}>
          {`Hits :`}
          <span style={{ color: "#4a46fb" }}>{` ${hits}`}</span>
        </span>
        <div
          className="d-flex justify-content-right align-items-center "
          style={{
            fontSize: "large",
            fontWeight: "700",
            color: "white",
          }}
        >
          <LifeIndicator value={lifes} totalLifes={totalLifes} />
          <img
            src={sound}
            onMouseOver={(e) => {
              e.currentTarget.src = soundHover;
            }}
            onMouseOut={(e) => {
              e.currentTarget.src = sound;
            }}
            className={
              isSoundOn ? "ml-5 settings-button" : "ml-5 sound-disabled-button"
            }
            alt="sound"
            onClick={() => setIsSoundOn(!isSoundOn)}
            style={{ width: 35 }}
          ></img>
          <img
            src={settings}
            onMouseOver={(e) => {
              e.currentTarget.src = settingsHover;
            }}
            onMouseOut={(e) => {
              e.currentTarget.src = settings;
            }}
            className="ml-3 settings-button"
            alt="settings"
            onClick={() => {
              setIsSettingsOpen(true);
            }}
            style={{ width: 35 }}
          ></img>
        </div>
      </div>
      <div
        id="elem"
        style={{
          height: window.innerHeight - 200,
          width: window.innerWidth,
          padding: paddingX,
          position: "relative",
        }}
        className="d-flex justify-content-center align-items-center mt-2"
        tabIndex={0}
      >
        {!gameStarted ? (
          <Play
            width={window.innerWidth - 4 * paddingX}
            height={460}
            startGame={startGame}
            spawnRateLimit={spawnRateLimit}
            spawnRateIncrease={spawnRateIncrease}
            setSpawnRateLimit={setSpawnRateLimit}
            setSpawnRateIncrease={setSpawnRateIncrease}
            totalLifes={totalLifes}
            setTotalLifes={setTotalLifes}
            speed={speed}
            setSpeed={setSpeed}
          />
        ) : !playing ? (
          <ChallengeResults
            width={window.innerWidth - 6 * paddingX}
            height={460}
            data={data.current}
            startGame={startGame}
          />
        ) : null}
        {isCountDown ? (
          <CountDownTimer
            width={window.innerWidth - 4 * paddingX}
            height={460}
          />
        ) : null}

        <canvas
          style={{
            position: "absolute",
            marginTop: "auto",
            marginBottom: "auto",
          }}
          tabIndex={0}
          className="custom-canvas mouse-cursor-4"
          onClick={handleCanvasClick}
          id="canvas"
          ref={canvasRef}
          width={window.innerWidth - 4 * paddingX}
          height={canvasHeight}
        ></canvas>
      </div>

      <div
        className="d-flex justify-content-left"
        style={{
          width: "max-content",
          marginTop: "auto",
          marginLeft: 2 * paddingX,
          marginBottom: "auto",
          transform: "translateY(5%)",
        }}
      >
        <img
          src={restart}
          alt="restart"
          style={{ float: "left" }}
          height="35"
        ></img>
        <div className="full-screen mt-1 mb-2 mx-3" onClick={finishGame}>
          Restart
        </div>

        <img
          src={fullScreen}
          alt="fullScreen"
          style={{ float: "left", marginLeft: 20 }}
          height="35"
        ></img>
        <div
          className="full-screen mt-1 mb-2 mx-3"
          onClick={() => document.documentElement.requestFullscreen()}
        >
          Full Screen
        </div>
      </div>
    </div>
  );
};

export default ChallengeArena;
